import { Component, OnInit } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { trigger, transition, animate, style, state } from '@angular/animations';

@Component({
  selector: 'app-ani-fade',
  templateUrl: './ani-fade-example.component.html',
  styleUrls: ['./ani-fade-example.component.scss'],
  animations: [
    trigger('someCoolAnimation', [
        state('fadeIn' , style({ opacity: 1 })),
        state('fadeOut', style({ opacity: 0 })),
        transition('* => fadeOut', animate('1.5s')),
        transition('fadeOut => fadeIn', animate('.5s'))
    ])
  ]
})
export class AniFadeExampleComponent implements OnInit {

  bindingVar = '';

  constructor() { }

  ngOnInit() {
  }
  

  fadeIn() {
    this.bindingVar = 'fadeIn';
  }
  fadeOut() {
    this.bindingVar = 'fadeOut';
  }
  toggle() {
    this.bindingVar === 'fadeOut' ? this.fadeIn() : this.fadeOut();
  }
}
